import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-get-started',
  templateUrl: './get-started.component.html',
  styleUrls: ['./get-started.component.scss']
})
export class GetStartedComponent implements OnInit {
    title = 'Get Started !';
    subTitle = 'Check out the videos below to get started !';
    cardType = 'getStarted';
    buttonType = 'Video';
    apiGetStarted = [
        {
            videoId: 'nlnCtyvJUHI',
            title: 'Quick Navigation at apiplatform.io',
            caption: 'Navigate through apiplatform.io',
            image: './assets/img/getStarted/data-access-api-thumb.png',
            routeTo: ''
        },
        {
            title: 'Data Access API',
            caption: 'Get started with Data Access API Builder',
            videoId: 'dAyZQM4W2eQ',
            image: './assets/img/getStarted/data-access-api-thumb.png',
            routeTo: ''
        },
        {
            title: 'Business Logic API',
            caption: 'Get started with Business Logic Builder',
            videoId: 'YY4PzvHOOuE',
            image: './assets/img/getStarted/business-logic-api-thumb.png',
            routeTo: ''
        },
        {
            title: 'SQL Query API',
            caption: 'Get started with SQL Query API Builder',
            videoId: 'DlyoS-C7m04',
            image: './assets/img/getStarted/business-logic-api-thumb.png',
            routeTo: ''
        }
    ];
    apiGetStarted1 = [
    {
        title: 'Data Access API',
        caption: 'Get started with Data Access API Builder',
        video: './assets/vid/data-access-api-get-started.mp4',
        image: './assets/img/getStarted/data-access-api-thumb.png',
        routeTo: ''
    },
    {
        title: 'Business Logic API',
        caption: 'Get started with Business Logic Builder',
        video: './assets/vid/business-logic-api-get-started.mp4',
        image: './assets/img/getStarted/business-logic-api-thumb.png',
        routeTo: ''
    },
    // {
    //     title: 'Workflow API',
    //     caption: 'Get started with Workflow Builder',
    //     video: './assets/vid/workflow-api-get-started.mp4',
    //     image: './assets/img/getStarted/workflow-api-thumb.png',
    //     routeTo: ''
    // },
    // {
    //     title: 'Decision API',
    //     video: '',
    //     image: './assets/img/getStarted/businessLogicThumbnail.png',
    //     routeTo: ''
    // },
    {
        title: 'SQL Query API',
        caption: 'Get started with SQL Query API Builder',
        video: './assets/vid/sql-query-api-get-started.mp4',
        image: './assets/img/getStarted/sql-query-api-thumb.png',
        routoTo: ''
    },
    {
            title: 'API Connectors',
            caption: 'Get started with API Connectors',
            video: './assets/vid/api-connectors-get-started.mp4',
            image: './assets/img/getStarted/api-connectors-thumb.png',
            routoTo: ''
    },
        // {
        //     title: 'Open API to API',
        //     caption: 'Transform Open API Spec to API',
        //     video: './assets/vid/open-api-to-api-get-started.mp4',
        //     image: './assets/img/getStarted/open-api-to-api-thumb.png',
        //     routoTo: ''
        // },
        // {
        //     title: 'Database to API',
        //     caption: 'Get started with Database to API',
        //     video: './assets/vid/database-to-api-get-started.mp4',
        //     image: './assets/img/getStarted/database-to-api-thumb.png',
        //     routoTo: ''
        // }
    ];
  constructor() { }

  ngOnInit(): void {
  }

}

